import { attr, belongsTo } from '@warp-drive/legacy/model';

import Model from 'umg-ember-backend/models/mlp-module';
import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  streamId: validator('presence', true),
});

export const settings = {
  copyableOptions: { ignoreAttributes: ['contentItem'] },
};

export default class MlpStagePlusStreamModel extends Model.extend(Validations) {
  @attr('string') streamId;

  @belongsTo('asset', { async: true, inverse: null }) posterImage;

  // Getter and setter
  get displayHeadline() {
    return this.streamId;
  }
}
